import styled, { keyframes } from "styled-components";

const bp = { md: "768px" };

const c = {
  black: "#1e1e1e",
  white: "#ffffff",

  gold: "#c9a227",
  goldSoft: "rgba(201,162,39,0.22)",

  pink: "#fc9ac4",
  pinkStrong: "#ff77b4",
  pinkSoft: "rgba(252,154,196,0.18)",

  textOnBlack: "rgba(255,255,255,0.92)",
  line: "rgba(255,255,255,0.08)",
  hairline: "rgba(0,0,0,0.08)",

  shadow: "0 18px 45px rgba(0,0,0,0.35)",
  glowPink: "0 0 18px rgba(252,154,196,0.22)",
};

const marquee = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

export const MobileCatsSlot = styled.div`
  display: none;

  @media (max-width: ${bp.md}) {
    display: block;
    background: transparent;
  }
`;

export const DesktopMarquee = styled.div`
  display: block;
  @media (max-width: ${bp.md}) {
    display: none;
  }
`;
export const MobileMarquee = styled.div`
  display: none;
  @media (max-width: ${bp.md}) {
    display: block;
  }
`;

export const MarqueeBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1105;

  background: ${c.white};
  border-bottom: 1px solid ${c.hairline};
  border-top: 1px solid rgba(201, 162, 39, 0.45);

  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.06),
    inset 0 1px 0 rgba(252, 154, 196, 0.16);

  height: 46px;
  display: flex;
  align-items: center;

  transform: translateY(${(p) => (p.$hidden ? "-46px" : "0px")});
  opacity: ${(p) => (p.$hidden ? 0 : 1)};
  pointer-events: ${(p) => (p.$hidden ? "none" : "auto")};
  transition:
    transform 0.28s cubic-bezier(0.22, 1, 0.36, 1),
    opacity 0.18s ease;
`;

export const MarqueeInner = styled.div`
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`;

export const MarqueeTrack = styled.div`
  display: inline-flex;
  align-items: center;
  width: max-content;
  animation: ${marquee} 78s linear infinite;

  will-change: transform;
  backface-visibility: hidden;
  transform: translateZ(0);

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const MarqueeItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;

  font-size: 12px;
  letter-spacing: 0.2em;

  height: 42px;
  padding: 0 24px;

  font-weight: 900;
  text-transform: uppercase;
  color: ${c.black};

  .txt {
    color: ${c.black};
    opacity: 0.92;
  }

  .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${c.pink};
  }

  svg {
    display: block;
  }
  svg .stroke {
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  svg .fill {
    fill: currentColor;
    stroke: currentColor;
    stroke-width: 1.4;
  }
  svg .fillSoft {
    fill: currentColor;
    opacity: 0.25;
  }
`;

export const NavWrap = styled.header`
  position: fixed;
  left: 0;
  right: 0;

  z-index: 1000;

  top: ${(p) => {
    if (p.$hideMarquee) return "0px";
    return p.$docked ? "0px" : "46px";
  }};
  transition: top 0.28s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: top;

  html[style*="--cats-drawer-open: 1"] & {
    z-index: 20000;
  }
`;

export const TopNav = styled.div`
  background: ${c.black};
  position: relative;

  border-top: 1px solid ${c.gold};
  border-bottom: 3px solid ${c.gold};

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    inset 0 -1px 0 rgba(255, 255, 255, 0.06);

  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 2px;
    height: 1px;
    background: rgba(255, 255, 255, 0.08);
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 2px;
    height: 1px;
    background: rgba(255, 255, 255, 0.08);
  }

  @media (max-width: ${bp.md}) {
    border-top-width: 1.5px;
    border-bottom-width: 1.5px;
  }
`;

export const TopInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  height: 78px;
  padding: 0 22px;

  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;

  @media (max-width: ${bp.md}) {
    height: 68px;
    padding: 0 14px;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
`;

export const LogoWrap = styled.a`
  display: inline-flex;
  align-items: center;
  text-decoration: none;

  img {
    height: 55px;
    width: auto;
    filter: drop-shadow(0 10px 22px rgba(0, 0, 0, 0.45));
    opacity: 0.98;

    @media (max-width: ${bp.md}) {
      height: 40px;
    }
  }
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
`;

export const Brand = styled.a`
  text-decoration: none;
  color: ${c.textOnBlack};

  font-family: "Cormorant Garamond", serif;
  font-weight: 600;
  font-size: 38px;
  letter-spacing: 0.26em;
  text-transform: uppercase;

  position: relative;
  padding: 8px 10px 18px;

  span {
    color: ${c.textOnBlack};
    font-weight: 500;
    opacity: 0.9;
  }

  &::after {
    content: "";
    position: absolute;
    left: 28%;
    right: 28%;
    bottom: 6px;
    height: 1.5px;
    background: ${c.gold};
    opacity: 0.85;
  }

  &::before {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 2px;
    transform: translateX(-50%) rotate(45deg);
    width: 8px;
    height: 8px;
    background: ${c.gold};
  }

  @media (max-width: ${bp.md}) {
    font-size: 18px;
    letter-spacing: 0.18em;
    margin-right: 5px;

    &::after {
      left: 22%;
      right: 22%;
    }

    &::before {
      width: 6px;
      height: 6px;
      bottom: 3px;
    }
  }
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

export const IconPill = styled.a`
  height: 42px;
  padding: 0 14px;
  border-radius: 999px;

  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;

  color: ${c.pink};
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(201, 162, 39, 0.28);

  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.28);

  transition:
    transform 0.15s ease,
    border-color 0.15s ease,
    background 0.15s ease,
    filter 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(252, 154, 196, 0.7);
    background: rgba(255, 255, 255, 0.07);
    filter: drop-shadow(${c.glowPink});
  }

  @media (max-width: ${bp.md}) {
    display: none;
  }
`;

export const IconRound = styled.button`
  width: 42px;
  height: 42px;
  border-radius: 999px;
  cursor: pointer;
  position: relative;

  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(201, 162, 39, 0.28);

  transition:
    transform 0.15s ease,
    border-color 0.15s ease,
    background 0.15s ease,
    filter 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(252, 154, 196, 0.7);
    background: rgba(255, 255, 255, 0.07);
    filter: drop-shadow(${c.glowPink});
  }

  svg {
    display: block;
    margin: 0 auto;
    color: ${c.pink};
  }

  display: none;
  @media (max-width: ${bp.md}) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
  }
`;

export const BurgerBtn = styled(IconRound)`
  span {
    position: absolute;
    left: 12px;
    right: 12px;
    height: 2px;
    border-radius: 2px;
    background: ${c.pink};
    opacity: 0.95;
  }

  span:nth-child(1) {
    top: 13px;
  }
  span:nth-child(2) {
    top: 19px;
  }
  span:nth-child(3) {
    top: 25px;
  }

  @media (min-width: calc(${bp.md} + 1px)) {
    display: none;
  }
`;

export const SubNav = styled.nav`
  background: rgba(255, 255, 255, 0.975);
  border-bottom: 1px solid ${c.hairline};
  position: relative;
  z-index: 3;

  height: 62px;
  display: flex;
  align-items: center;

  box-shadow:
    0 12px 24px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.92);

  backdrop-filter: blur(8px);

  &::before {
    content: "";
    position: absolute;
    left: 22px;
    right: 22px;
    top: 0;
    height: 1px;
    background: ${c.gold};
    opacity: 0.45;
  }

  &::after {
    content: "";
    position: absolute;
    left: 22px;
    right: 22px;
    bottom: 0;
    height: 1px;
    background: rgba(201, 162, 39, 0.22);
  }

  @media (max-width: ${bp.md}) {
    display: none;
  }
`;

export const SubInner = styled.div`
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 0 22px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SubLinks = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  display: flex;
  align-items: center;
  gap: 28px;
`;

export const SubItem = styled.li`
  display: flex;
  align-items: center;
  gap: 28px;

  &:not(:last-child)::after {
    content: "";
    width: 6px;
    height: 6px;
    background: ${c.gold};
    transform: rotate(45deg);
    opacity: 0.85;
  }
`;

export const SubLink = styled.a`
  text-decoration: none;
  color: rgba(0, 0, 0, 0.9);

  font-family: "Cormorant Garamond", serif;
  font-weight: 1000;
  font-size: 18px;
  letter-spacing: 0.2em;
  text-transform: uppercase;

  position: relative;
  padding: 12px 6px;

  transition:
    color 0.16s ease,
    transform 0.16s ease;

  &:hover {
    color: ${c.pinkStrong};
    transform: translateY(-1px);
  }

  &::after {
    content: "";
    position: absolute;
    left: 12%;
    right: 12%;
    bottom: 6px;
    height: 1.5px;
    background: ${c.gold};
    opacity: 0;
    transform: scaleX(0.75);
    transition:
      opacity 0.16s ease,
      transform 0.16s ease;
  }

  &:hover::after {
    opacity: 0.9;
    transform: scaleX(1);
  }
`;

export const MobileDropWrap = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: ${(p) => (p.$top ? `${p.$top}px` : "68px")};

  z-index: 1250;

  display: none;
  @media (max-width: 768px) {
    display: block;
  }

  opacity: ${(p) => (p.$open && typeof window !== "undefined" ? 1 : 0)};
  pointer-events: ${(p) => (p.$open ? "auto" : "none")};

  html[style*="--cats-drawer-open: 1"] & {
    opacity: 0 !important;
    pointer-events: none !important;
    display: none !important;
  }

  transition: opacity 0.18s ease;
`;

export const MobileDropInner = styled.div`
  width: min(320px, calc(100vw - 90px));
  margin-left: auto;

  border-radius: 18px;
  background: ${c.black};
  border: 1px solid rgba(201, 162, 39, 0.38);
  box-shadow:
    0 28px 70px rgba(0, 0, 0, 0.55),
    inset 0 1px 0 rgba(252, 154, 196, 0.12);

  overflow: hidden;
  position: relative;

  transform: ${(p) => (p.$open ? "translate(0, 0)" : "translate(10px, -10px)")};
  transition: transform 0.22s ease;

  &::after {
    content: "";
    position: absolute;
    left: 14px;
    right: 14px;
    top: 0;
    height: 1px;
    background: ${c.gold};
    opacity: 0.45;
  }
`;

export const MobileDropList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 10px 14px 6px;
`;

export const MobileDropItem = styled.li``;

/**
 * IMPORTANT:
 * Folosim MobileDropLink atât ca <a href="..."> cât și ca <button> (as="button").
 * De aceea am normalizat border/background/cursor ca să arate identic în ambele cazuri.
 */
export const MobileDropLink = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 14px 8px;
  text-decoration: none;

  color: ${c.textOnBlack};
  font-family: "Cormorant Garamond", serif;
  font-size: 20px;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  border: 0;
  background: transparent;
  cursor: pointer;

  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  transition:
    color 0.15s ease,
    transform 0.15s ease,
    background 0.15s ease;

  &:hover {
    color: ${c.pink};
    transform: translateX(2px);
    background: rgba(252, 154, 196, 0.06);
  }

  &:focus-visible {
    outline: 2px solid rgba(252, 154, 196, 0.55);
    outline-offset: 2px;
    border-radius: 10px;
  }
`;

export const MobileBottomBar = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1300;

  background: ${c.black};
  border-top: 1px solid rgba(201, 162, 39, 0.45);
  box-shadow:
    0 -22px 45px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(252, 154, 196, 0.1);

  display: none;

  @media (max-width: ${bp.md}) {
    display: flex;
    align-items: center;

    min-height: 60px;
    padding-top: 8px;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: calc(8px + env(safe-area-inset-bottom));
    padding-bottom: calc(8px + constant(safe-area-inset-bottom));
  }
`;

export const MobileBottomInner = styled.div`
  width: 100%;
  padding: 0 12px;
  grid-template-columns: 1fr auto;

  display: grid;
  align-items: center;
`;

export const CartPill = styled.button`
  height: 44px;
  border-radius: 12px;
  border: 1px solid rgba(201, 162, 39, 0.28);
  background: rgba(255, 255, 255, 0.06);
  cursor: pointer;
  width: 100%;

  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.28);
  transition:
    transform 0.15s ease,
    border-color 0.15s ease,
    background 0.15s ease;

  &:active {
    transform: translateY(1px);
  }

  @media (hover: hover) {
    &:hover {
      border-color: rgba(252, 154, 196, 0.65);
      background: rgba(255, 255, 255, 0.08);
    }
  }

  display: grid;
  grid-template-columns: 34px 1fr auto;
  align-items: center;
  gap: 10px;

  padding: 0 12px;

  .lbl {
    color: ${c.white};
    font-family: Georgia, "Times New Roman", Times, serif;
    font-weight: 900;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    font-size: 11px;
    opacity: 0.92;
  }

  .sum {
    color: ${c.pink};
    font-family: Georgia, "Times New Roman", Times, serif;
    font-weight: 900;
    letter-spacing: 0.08em;
    font-size: 14px;

    font-variant-numeric: lining-nums tabular-nums;
    font-feature-settings:
      "lnum" 1,
      "tnum" 1;
  }

  svg {
    color: ${c.pink};
  }
`;

export const MobileTotal = styled.div`
  color: ${c.white};
  font-weight: 900;
  letter-spacing: 0.1em;
  font-size: 12px;
  opacity: 0.9;
  text-align: right;
`;

export const MobileBottomSpacer = styled.div`
  display: none;

  @media (max-width: ${bp.md}) {
    display: block;
  }
`;

export const HeaderSpacer = styled.div``;

export const UserMenuWrap = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const LogoutToast = styled.div`
  position: fixed;
  top: 92px;
  right: 18px;
  z-index: 50000;

  background: rgba(20, 20, 20, 0.96);
  border: 1px solid rgba(252, 154, 196, 0.35);
  border-radius: 14px;

  padding: 14px 18px;

  color: rgba(255, 255, 255, 0.95);
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 12px;

  box-shadow:
    0 20px 50px rgba(0, 0, 0, 0.55),
    0 0 20px rgba(252, 154, 196, 0.25);

  animation: fadeIn 0.22s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const CartToast = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 80px; /* 👈 deasupra bottom bar */
  z-index: 99999;

  min-width: max-content;
  max-width: calc(100vw - 24px);
  padding: 12px 18px;
  border-radius: 999px;

  background: #c9a227;
  color: #ffffff;
  border: 1px solid #c9a227;
  box-shadow: 0 10px 24px rgba(160, 126, 33, 0.16);

  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-align: center;
  white-space: nowrap;

  @media (min-width: 769px) {
    bottom: 24px; /* desktop rămâne jos */
  }
`;
